import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function Forbidden() {
  useEffect(() => {
    document.title = 'Ingen adgang - Kristensen Byg og Montage ApS'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Du har ikke adgang til denne side. Gå tilbage til forsiden af Kristensen Byg og Montage ApS.'
      )
    }
  }, [])

  return (
    <div className="bg-warm-gray-50 min-h-[calc(100vh-20rem)] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center bg-white p-10 rounded-lg border border-warm-gray-200 shadow-sm">
        <div className="h-16 w-16 rounded-full bg-red-50 text-red-600 flex items-center justify-center mx-auto mb-6 border border-red-100">
          <i className="fa-light fa-lock-keyhole text-2xl" />
        </div>
        <span className="text-sm font-bold text-red-600 uppercase tracking-widest">Fejl 403</span>
        <h1 className="text-2xl sm:text-3xl font-bold uppercase tracking-wider text-anthracite mt-3 mb-4">
          Adgang nægtet
        </h1>
        <p className="text-sm text-warm-gray-600 leading-relaxed mb-8">
          Du har ikke tilladelse til at tilgå denne side. Hvis du mener, at dette er en fejl, bedes du kontakte os.
        </p>
        <div className="flex flex-col gap-3">
          <Link
            to="/"
            className="w-full rounded bg-brand-green py-3 text-sm font-bold text-white shadow-sm hover:bg-brand-green-hover transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <i className="fa-light fa-house" />
            gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="w-full rounded bg-warm-gray-100 border border-warm-gray-200 py-3 text-sm font-bold text-warm-gray-700 hover:bg-warm-gray-200 transition-colors duration-200"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  )
}
